import type { Center } from '@/types/models'
import { isNumber } from '@/utils/checks'

const MAXIMUM_PRIORITY_OFFSET = 300000

export const handleAdCenterPriority = (adCenter: Center) => {
  if (isNumber(adCenter?.priority)) {
    return MAXIMUM_PRIORITY_OFFSET + Math.round(adCenter.priority)
  }

  return 0
}
